import script from "./TableFull.vue?vue&type=script&setup=true&lang=js"
export * from "./TableFull.vue?vue&type=script&setup=true&lang=js"

import "./TableFull.vue?vue&type=style&index=0&id=4be5c94e&lang=css"

const __exports__ = script;

export default __exports__